import { getCashflowForecast, getShortTermCashflow } from '@/api/apiDeck'
import { logoutRoutine } from '@/store/modules/auth/routines'
import requestFlow from '@/utils/requestFlow'
import { state as initialState } from './index'
import { CASH_FLOW_DETAILS_CLEANUP, CASH_FLOW_FORECAST_CLEANUP, cashFlowForecastRoutine, cashFlowRoutine, cashflowForecastCleanupRoutine } from './routines'

export default {
  ...requestFlow(cashFlowRoutine, getShortTermCashflow).actions,
  ...requestFlow(cashFlowForecastRoutine, getCashflowForecast).actions,

  [logoutRoutine.SUCCESS](context) {
    context.commit(CASH_FLOW_DETAILS_CLEANUP, initialState)
    context.commit(CASH_FLOW_FORECAST_CLEANUP, initialState)
  },

  [cashflowForecastCleanupRoutine.TRIGGER](context) {
    context.commit(CASH_FLOW_DETAILS_CLEANUP, initialState)
  }
}
